import { LoadingKey } from './key'
import ContentLoader from './react-content-loader'

const CommunityLoading = () => {
  return (
    <ContentLoader
      uniqueKey={LoadingKey.community}
      viewBox='0 0 480 180'
      foregroundColor='var(--background-1st)'
      backgroundColor='var(--background-2nd)'
      speed={1.5}
      interval={0.5}
      gradientRatio={1}
    >
      <rect x='12' y='20' rx='999' width='36' height='36' />
      <rect x='52' y='20' rx='4' ry='4' width='414' height='120' />

      <circle cx='70' cy='160' r='10' />
      <circle cx='100' cy='160' r='10' />
      <circle cx='130' cy='160' r='10' />
      <circle cx='160' cy='160' r='10' />
    </ContentLoader>
  )
}

export default CommunityLoading
